import React, { useState } from 'react'
import MailTemplate from './MailCommunication'
import LogsDetails from './Logs'
import NotificationCommunication from './NotificationCommunication'
import Whatsapp from './Whatsapp'
const DetailMainPage = ({ rowData, loginType }) => {
    const [viewScreen, setViewScreen] = useState('mail')

    const leadPageHandler = (e) => {
        setViewScreen(e)
    }

    return (
        <div className='container-fluid full-height'>
            <div className='row'>
                <ul className='detail-page-hr-sub-tabs' style={{ paddingTop: '10px' }}>
                    <li className={viewScreen === 'mail' ? 'communication-btn-active communication-btn' : 'communication-btn'} onClick={e => leadPageHandler('mail')}>Email</li>
                    {window.location.href.includes('/admin')?<li className={viewScreen === 'whatsapp' ? 'communication-btn-active communication-btn' : 'communication-btn'} onClick={e => leadPageHandler('whatsapp')}>Whats App</li>:""}
                    {/* <li className={viewScreen === 'txtmsg' ? 'active' : ''} onClick={e => leadPageHandler('txtmsg')}>Text Messages</li> */}
                    <li className={viewScreen === 'notification' ? 'communication-btn-active communication-btn' : 'communication-btn'} onClick={e => leadPageHandler('notification')}>Notification</li>
                    <li className={viewScreen === 'logs' ? 'communication-btn-active communication-btn' : 'communication-btn'} onClick={e => leadPageHandler('logs')}>Logs</li>
                </ul>
            </div>
            <div className='row'>
                {viewScreen === 'mail' ?
                    <MailTemplate
                        rowData={rowData}
                        viewScreen={viewScreen}
                        loginType={loginType}
                    />
                    : ""}
                {viewScreen === 'logs' ?
                    <LogsDetails rowData={rowData} />
                    : ""}
                {viewScreen === 'notification' ?
                    <NotificationCommunication rowData={rowData}
                        viewScreen={viewScreen}
                        loginType={loginType} />
                    : ""}
                {viewScreen === 'whatsapp' ?
                    <Whatsapp
                    rowData={rowData}

                    />
                    : ""}
            </div>
        </div>
    )
}

export default DetailMainPage;